
const state = {
  filter: ''
}

const getters = {
  getFilter: state => state.filter
}

const actions = {
}

const mutations = {
  'UPDATE_FILTER': (state, filter) => { state.filter = filter }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
